"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfinityTable = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _table = require("./table");

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var computeState = function computeState(_ref, _ref2) {
  var pageSize = _ref.pageSize;
  var direction = _ref2.direction,
      scrollTop = _ref2.scrollTop,
      scrollHeight = _ref2.scrollHeight,
      tableHeight = _ref2.tableHeight,
      visibleHeight = _ref2.visibleHeight,
      size = _ref2.size;

  if (scrollHeight === 0 || scrollHeight === 1) {
    return {
      startIndex: 0,
      underHeight: 0,
      upperHeight: 0,
      visibleRowCount: 0
    };
  }

  var rowHeight = tableHeight / pageSize;
  var visibleRowCount = Math.ceil(visibleHeight / rowHeight);
  var startIndex = Math.floor(scrollTop / scrollHeight * size);

  if (direction === 'up') {
    startIndex -= pageSize - visibleRowCount;
    startIndex = startIndex < 0 ? 0 : startIndex;
  } else {
    startIndex = startIndex + pageSize > size ? size - pageSize : startIndex;
  }

  var underHeight = Math.round((size - (startIndex + pageSize)) * rowHeight);
  startIndex = startIndex > 0 ? startIndex : 0;
  var upperHeight = Math.round(startIndex * rowHeight);
  return {
    visibleRowCount: visibleRowCount,
    startIndex: startIndex,
    underHeight: underHeight,
    upperHeight: upperHeight
  };
};

var InfinityTable = (_dec = (0, _vuePropertyDecorator.Prop)(), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: 'key'
}), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec5 = (0, _vuePropertyDecorator.Prop)(), _dec6 = (0, _vuePropertyDecorator.Prop)({
  default: 'middle'
}), _dec7 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec8 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec9 = (0, _vuePropertyDecorator.Prop)({
  default: 30
}), _dec10 = (0, _vuePropertyDecorator.Prop)(), _dec11 = (0, _vuePropertyDecorator.Watch)('dataSource'), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(InfinityTable, _Vue);

  var _super = _createSuper(InfinityTable);

  function InfinityTable() {
    var _this;

    (0, _classCallCheck2.default)(this, InfinityTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "columns", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "dataSource", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "rowKey", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "scroll", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "customRow", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "size", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "bordered", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "loading", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "renderSize", _descriptor9, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "footerData", _descriptor10, (0, _assertThisInitialized2.default)(_this));
    _this.isPropsChange = false;
    _this.cacheSize = 0;
    _this.scrollTop = 0;
    _this.scrollHeight = 0;
    _this.tableHeight = 0;
    _this.visibleRowCount = 0;
    _this.visibleHeight = 0;
    _this.startIndex = 0;
    _this.upperHeight = 0;
    _this.underHeight = 0;
    _this.refScroll = null;
    _this.refLeftScroll = null;
    _this.refRightScroll = null;
    _this.refTable = null;
    _this.setStateWithThrottle = (0, _throttle.default)(_this.updateTable, 200);
    _this.io = null;
    _this.ioTargetState = {
      refUnderPlaceholder: null,
      refUpperPlaceholder: null,
      refTable: null
    };
    return _this;
  }

  (0, _createClass2.default)(InfinityTable, [{
    key: "factDataSource",
    get: function get() {
      var startIndex = this.startIndex,
          renderSize = this.renderSize;
      return this.dataSource.slice(startIndex, startIndex + renderSize);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$$refs$root, _this$refScroll, _root$getElementsByCl, _root$getElementsByCl2;

      var root = (_this$$refs$root = this.$refs.root) === null || _this$$refs$root === void 0 ? void 0 : _this$$refs$root.$el;
      this.refScroll = root === null || root === void 0 ? void 0 : root.getElementsByClassName('ant-table-body')[0];
      this.refTable = (_this$refScroll = this.refScroll) === null || _this$refScroll === void 0 ? void 0 : _this$refScroll.getElementsByTagName('tbody')[0];
      this.refLeftScroll = root === null || root === void 0 ? void 0 : (_root$getElementsByCl = root.getElementsByClassName('ant-table-fixed-left')[0]) === null || _root$getElementsByCl === void 0 ? void 0 : _root$getElementsByCl.getElementsByClassName('ant-table-body-inner')[0];
      this.refRightScroll = root === null || root === void 0 ? void 0 : (_root$getElementsByCl2 = root.getElementsByClassName('ant-table-fixed-right')[0]) === null || _root$getElementsByCl2 === void 0 ? void 0 : _root$getElementsByCl2.getElementsByClassName('ant-table-body-inner')[0];

      if (!this.refScroll) {
        return;
      }

      this.io = new IntersectionObserver(this.observerScrollCallBack, {
        root: this.refScroll
      });
      this.toggleObserver();
    }
  }, {
    key: "dataSourceChange",
    value: function dataSourceChange() {
      var _this2 = this;

      // this.handlePropsChange();
      this.$nextTick(function () {
        _this2.updateTable();
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var _this$refScroll2, _this$io;

      (_this$refScroll2 = this.refScroll) === null || _this$refScroll2 === void 0 ? void 0 : _this$refScroll2.removeEventListener('scroll', this.setStateWithThrottle);
      (_this$io = this.io) === null || _this$io === void 0 ? void 0 : _this$io.disconnect();
    }
  }, {
    key: "updateTable",
    value: function updateTable() {
      var _this3 = this;

      var _ref3 = this.refTable,
          tableHeight = _ref3.clientHeight;
      var _ref4 = this.refScroll,
          scrollHeight = _ref4.scrollHeight,
          visibleHeight = _ref4.clientHeight,
          scrollTop = _ref4.scrollTop; // if (!this.isPropsChange) {
      //   // fix bug: 当直接传入的dataSource数据量很大，无法滚动的问题。常见于不是按每页大小递增的情况，如1000条已有数据不需loading直接虚拟滚动显示的时候
      //   // 如果 isPropsChange === true 则下面的情况是合理的，不能退出state计算，要求重新计算
      //   if (
      //     // fix bug: 可能存在DOM更新时空白的情况，此种无效状态，需要过虑掉， （tableHeight 是很大的值，而this.state.tableHeight只是一个初始小值）
      //     (this.tableHeight &&
      //       Math.abs(tableHeight - this.tableHeight) > 200) || // 容许正常误差
      //     (this.scrollHeight &&
      //       Math.abs(scrollHeight - this.scrollHeight) > 200) ||
      //     (this.visibleHeight && visibleHeight !== this.visibleHeight)
      //   ) {
      //     return;
      //   }
      // }

      var obj = computeState({
        pageSize: this.renderSize
      }, {
        direction: scrollTop - this.scrollTop < 0 ? 'up' : 'down',
        scrollTop: scrollTop,
        visibleHeight: visibleHeight,
        scrollHeight: scrollHeight,
        tableHeight: tableHeight,
        size: this.dataSource.length
      });
      this.startIndex = obj.startIndex;
      this.visibleRowCount = obj.visibleRowCount;
      this.upperHeight = obj.upperHeight;
      this.underHeight = obj.underHeight;
      this.isPropsChange = false;
      this.cacheSize = this.dataSource.length;
      this.tableHeight = tableHeight;
      this.scrollTop = scrollTop;
      this.$nextTick(function () {
        var _this3$refScroll, _this3$refScroll2, _this3$refLeftScroll, _this3$refLeftScroll2, _this3$refRightScroll, _this3$refRightScroll2;

        (_this3$refScroll = _this3.refScroll) === null || _this3$refScroll === void 0 ? void 0 : _this3$refScroll.scrollTo((_this3$refScroll2 = _this3.refScroll) === null || _this3$refScroll2 === void 0 ? void 0 : _this3$refScroll2.scrollLeft, scrollTop);
        (_this3$refLeftScroll = _this3.refLeftScroll) === null || _this3$refLeftScroll === void 0 ? void 0 : _this3$refLeftScroll.scrollTo((_this3$refLeftScroll2 = _this3.refLeftScroll) === null || _this3$refLeftScroll2 === void 0 ? void 0 : _this3$refLeftScroll2.scrollLeft, scrollTop);
        (_this3$refRightScroll = _this3.refRightScroll) === null || _this3$refRightScroll === void 0 ? void 0 : _this3$refRightScroll.scrollTo((_this3$refRightScroll2 = _this3.refRightScroll) === null || _this3$refRightScroll2 === void 0 ? void 0 : _this3$refRightScroll2.scrollLeft, scrollTop);
      });
    }
  }, {
    key: "observerScrollCallBack",
    value: function observerScrollCallBack(changes) {
      var _this4 = this;

      if (!this.refScroll || !this.refTable) {
        return;
      }

      this.refScroll.removeEventListener('scroll', this.setStateWithThrottle); // if (
      //   this.scrollTop &&
      //   Math.abs(this.refScroll.scrollTop - this.scrollTop) < 20
      // ) {
      //   // 如果滚动步长小于20象素不做处理
      //   // console.log('scroll step less than 20px', this.refScroll.scrollTop - this.state.scrollTop);
      //   return;
      // }

      this.ioTargetState = changes.reduce(function (result, change) {
        var ret = _objectSpread({}, result);

        switch (change.target) {
          case _this4.$refs.underPlaceholder:
            ret.refUnderPlaceholder = change;
            break;

          case _this4.$refs.upperPlaceholder:
            ret.refUpperPlaceholder = change;
            break;

          case _this4.refTable:
            ret.refTable = change;
            break;

          default:
        }

        return ret;
      }, this.ioTargetState);
      var mutation = 'cache scrolling';
      var _this$ioTargetState = this.ioTargetState,
          refUnderPlaceholder = _this$ioTargetState.refUnderPlaceholder,
          refUpperPlaceholder = _this$ioTargetState.refUpperPlaceholder,
          refTable = _this$ioTargetState.refTable;
      var startIndex = this.startIndex,
          visibleRowCount = this.visibleRowCount,
          cacheSize = this.cacheSize,
          loading = this.loading,
          renderSize = this.renderSize;

      if (refUnderPlaceholder.intersectionRatio > 0) {
        if (refTable.intersectionRatio > 0 && startIndex + renderSize + visibleRowCount >= cacheSize && !loading) {
          // 已滚动到最后，加载数据
          mutation = 'end';
          this.scrollTop = this.refScroll.scrollTop;
          this.scrollHeight = this.refScroll.scrollHeight;
          this.tableHeight = this.refTable.clientHeight;
          return null; // mutation = 'fastEnd'; // 滚动到最后，但数据已经加载完
        } else if (refTable.intersectionRatio > 0) {
          mutation = 'down'; // 滚动到显示的数据未尾
        } else if (refTable.intersectionRatio === 0) {
          mutation = 'fastDown'; // 滚动到没有任何数据显示的区域
        }
      } else if (refUpperPlaceholder.intersectionRatio > 0) {
        if (refUpperPlaceholder.intersectionRatio === 1) {
          mutation = 'top'; // 滚动到顶了
        } else if (refTable.intersectionRatio > 0) {
          mutation = 'up'; // 滚动到显示的数据头部
        } else if (refTable.intersectionRatio === 0) {
          mutation = 'fastUp'; // 滚动到没有任何数据显示的区域
        }
      } else if (refTable.intersectionRatio === 0) {
        // fix bug: 重新触发，获取正确值
        this.toggleObserver(false);
        this.toggleObserver();
        return;
      }

      if (mutation.includes('fast')) {
        this.refScroll.addEventListener('scroll', this.setStateWithThrottle);
      }

      this.setStateWithThrottle();
    }
  }, {
    key: "toggleObserver",
    value: function toggleObserver() {
      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (condition) {
        var _this$io2, _this$io3, _this$io4;

        (_this$io2 = this.io) === null || _this$io2 === void 0 ? void 0 : _this$io2.observe(this.$refs.upperPlaceholder);
        (_this$io3 = this.io) === null || _this$io3 === void 0 ? void 0 : _this$io3.observe(this.$refs.underPlaceholder);
        (_this$io4 = this.io) === null || _this$io4 === void 0 ? void 0 : _this$io4.observe(this.refTable);
      } else {
        var _this$io5, _this$io6, _this$io7;

        (_this$io5 = this.io) === null || _this$io5 === void 0 ? void 0 : _this$io5.unobserve(this.$refs.upperPlaceholder);
        (_this$io6 = this.io) === null || _this$io6 === void 0 ? void 0 : _this$io6.unobserve(this.$refs.underPlaceholder);
        (_this$io7 = this.io) === null || _this$io7 === void 0 ? void 0 : _this$io7.unobserve(this.refTable);
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      return h(_table.MhTable, {
        props: _objectSpread(_objectSpread({}, this.$props), {}, {
          dataSource: this.factDataSource
        }),
        ref: 'root'
      }, [h('div', {
        style: {
          height: this.upperHeight + 'px'
        },
        slot: 'tableTop',
        ref: 'upperPlaceholder',
        key: 'upperPlaceholder'
      }), h('div', {
        style: {
          height: this.underHeight + 'px'
        },
        slot: 'tableBottom',
        ref: 'underPlaceholder',
        key: 'underPlaceholder'
      }), h('div', {
        style: {
          height: this.upperHeight + 'px'
        },
        slot: 'leftFixedTableTop',
        key: 'leftFixedTableTop'
      }), h('div', {
        style: {
          height: this.underHeight + 'px'
        },
        slot: 'leftFixedTableBottom',
        key: 'leftFixedTableBottom'
      }), h('div', {
        style: {
          height: this.upperHeight + 'px'
        },
        slot: 'rightFixedTableTop',
        key: 'rightFixedTableTop'
      }), h('div', {
        style: {
          height: this.underHeight + 'px'
        },
        slot: 'rightFixedTableBottom',
        key: 'rightFixedTableBottom'
      })]);
    }
  }], [{
    key: "install",
    value: function install(vue) {
      vue.component('mh-infinity-table', this);
    }
  }]);
  return InfinityTable;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "columns", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "dataSource", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "rowKey", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "scroll", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "customRow", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "size", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "bordered", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "loading", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "renderSize", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "footerData", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "dataSourceChange", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "dataSourceChange"), _class2.prototype)), _class2)) || _class);
exports.InfinityTable = InfinityTable;